module.exports = __webpack_public_path__ + "static/media/Vaishnavi_Lokhande_PHD_CV.c70a388b.pdf";